import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AppointmentManual } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    appoGroup: number;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const AppointmentManualEditor = ({ idSelector, onChange, label, appoGroup }: Props) => {

    const appointmentManual = useDataBean(_AppointmentManual)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector);
    }, [])

    useEffect(() => {
        getLista();
    }, [appoGroup])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        appointmentManual.instance.getAppointmentManualCatalog(appoGroup).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    return (
        <>
            <label>{label ?? "Manual de Funcion:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDAppointmentManual} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}